// ========== numbers =================

export const enum_accessLevelOptions = {
    player  : 1,
    guide   : 3,
    creator : 5,
    admin   : 10
}

export const enum_questPermission_n = {
    none    : 1,
    guide   : 3,
    editor  : 5,
    admin   : 7,
    owner   : 10,
}
export const enum_costCurrency_n = {
    SHEKEL: 1,
    DOLLAR: 2,
    EURO  : 3,
    // GPB     : 4,
    // AUD     : 5,
    // CAD     : 6,
}


export const enum_numbers = {
    sendEmailInterval: 8,
    hoursInDay: 24,
    hoursInTwoDay: (24 * 2),
    millisecondsInHour: (60*60*1000),
    minCost : 5,
}

export const enum_screenSizesOptions_n ={
    mobile          : 1,
    tablet_small    : 2,
    tablet_big      : 3,
    laptop          : 4,

}
export const enum_vibrationPatterns = {
    error : [200],
    success : [150],
}

// enum_subPlan_costDollars
export const enum_subPlan_costDollars = {
    free    : 0,
    basic   : 50,
    advanced : 150,
    pro     : 450,
    custom  : -1,
}

// enum_subPlan_activeQuests
export const enum_subPlan_activeQuests = {
    free    : 2,
    basic   : 5,
    advanced : 10,
    pro     : 20,
    custom  : -1,
}

// enum_subPlan_quests
export const enum_subPlan_quests = {
    free    : 5,
    basic   : 10,
    advanced : 20,
    pro     : 50,
    custom   : -1,
}

// enum_subPlan_events
export const enum_subPlan_events = {
    free     : 5,
    basic    : 10,
    advanced  : 30,
    pro      : -1,
    custom   : -1,
}

// enum_subPlan_players
export const enum_subPlan_players = {
    free    : 30,
    basic   : 100,
    advanced : 300,
    pro     : 1000,
}

// enum_paymentPlans_s
export const enum_subPlans_s = {
    free    : 'free',
    basic   : 'basic',
    advanced : 'advanced',
    pro     : 'pro',
    custom  : 'custom',
}


// enum_minMonthlySlotsTicketsPricing_n
export const enum_minMonthlySlotsTicketsPricing = {
    firstPlan_n   : 10,
    secondPlan_n  : 50,
    thirdPlan_n   : 100,
}

// enum_httpCodes_n
export const enum_httpCodes = {
    succeed_n : 200,
    succeed_noContent_n : 204,

    error_client_badRequest_n : 400,
    error_client_NOT_FOUND    : 404,
    error_client_wrongETag_n : 412,

    error_server_unknown_n : 0,
    error_server_n : 500
}

// enum_serverStatus
export const enum_serverStatus = {
    success : 1,
    failed : 0
}

// ========== strings =================

export const enum_fbPath = {

    // PRE_USERS_ACTIVITIES
    PRE_USERS_ACTIVITIES        : "PRE_USERS_ACTIVITIES",
    PRE_USERS_ACTIVITIES_login  : "login",

    // PRE_USERS_DATA
    PRE_USERS_DATA              : "PRE_USERS_DATA",
    ud_name_s                   : "ud_name_s",

    // PRE_USERS_QUESTS_TICKETS
    PRE_USERS_QUESTS_TICKETS    : "PRE_USERS_QUESTS_TICKETS",
    uqt_ticketsIds_ByTicketId   : "uqt_ticketsIds_ByTicketId",

    // PRE_USERS_CREATED_QUESTS
    PRE_USERS_CREATED_QUESTS            : "PRE_USERS_CREATED_QUESTS",
    PUCQ_ucq_questsPointers_byQuestId   : "ucq_questsPointers_byQuestId",

    DATA : "DATA",

    gst_players_byUserId_c : "gst_players_byUserId_c",

    questsEvent_startingDate : 'qev_startingDate_t',
    qev_ticketsStatus_byTicketId_b : 'qev_ticketsStatus_byTicketId_b',
    qev_eventId_uid : 'qev_eventId_uid',

    // gameStatus
    gs_timeExtensionMinutes_n : 'gs_timeExtensionMinutes_n',

    ms_readMsg_byUserId_b : 'ms_readMsg_byUserId_b',
    ms_receiveMsg_byUserId_b : 'ms_receiveMsg_byUserId_b',

    qbr_riddleId_n : 'qbr_riddleId_n',
    qbmg_missionsGroupId_n : 'qbmg_missionsGroupId_n',
    fi_index_n : 'fi_index_n',

    // storage
    storage_questExploreMainImageEnding : '_0.jpg',
}
export const enum_serverChildrenNames = {

    PRE_USERS_ACTIVITIES        : "PRE_USERS_ACTIVITIES",
    PRE_USERS_DATA              : "PRE_USERS_DATA",
    PRE_USERS_QUESTS_TICKETS    : "PRE_USERS_QUESTS_TICKETS",
    PRE_USERS_CREATED_QUESTS    : "PRE_USERS_CREATED_QUESTS",

    PRE_TICKET_SHORT_KEY : "PRE_TICKET_SHORT_KEY",

    SERVER_QUESTS_EVENTS_FINISH_EMAIL : "SERVER_QUESTS_EVENTS_FINISH_EMAIL",

    QUESTS_EVENTS : "QUESTS_EVENTS",
    QUESTS_EVENTS_ticketsStatus : "qev_ticketsStatus_byTicketId_b",

    USERS : "USERS",
    USERS_PLAYER_QUESTS_TICKETS : "PLAYER_QUESTS_TICKETS",
    USERS_DATA : "DATA",

    // users subCollections
    PRE_USERS_DATA_SUB_COLLECTION : "PRE_USERS_DATA_SUB_COLLECTION",
    PRE_USERS_DATA_SUB_COLLECTION_MORE_INFO : "MORE_INFO",
    PRE_USERS_DATA_SUB_COLLECTION_CREDIT_CARD : "CREDIT_CARD",
    PRE_USERS_DATA_SUB_COLLECTION_CREATOR_PAYMENT_INFO : "CREATOR_PAYMENT_INFO",
    PRE_USERS_DATA_SUB_COLLECTION_SUBSCRIPTION_PLAN_INFO : "SUBSCRIPTION_PLAN_INFO",
    PRE_USERS_DATA_SUB_COLLECTION_CHARGE_PAYMENT_HISTORY : "CHARGE_PAYMENT_HISTORY",

    CREATED_QUESTS : "CREATED_QUESTS",
    QUESTS_TICKETS : "QUESTS_TICKETS",
    CREATOR_MONTHLY_TICKETS : "CREATOR_MONTHLY_TICKETS",
    QUESTS_TICKETS_qt_saleDate_t : "qt_saleDate_t",
    QUESTS_TICKETS_EMAIL : "QUESTS_TICKETS_EMAIL",
    QUESTS_TICKETS_PAYMENT : "QUESTS_TICKETS_PAYMENT",
    QUESTS_TICKETS_qt_status_e: "qt_status_e",

    TICKETS_MANAGER : "TICKETS_MANAGER",
    TICKETS_MANAGER_x_hour : "_HOURS",
    TICKETS_MANAGER_x_hour_ticketsPointers : "tm_ticketsPointers_byTicketIdB",

    GAME_STATUS : "GAME_STATUS",

    FIRESTORE_QUEST_BODY_qb_metadata_c : "qb_metadata_c",

    VARIABLES : "VARIABLES",
    VARIABLES_userPermissions_byUserId_n : "userPermissions_byUserId_n",

}
export const enum_questTypes = {
    CARDS   : "CARDS",
    OPEN_MAP: "OPEN_MAP",
    MISSIONS: "MISSIONS",
}
export const enum_typeof = {
    string      : "string",
    number      : "number",
    boolean     : "boolean",
    function    : "function",
    undefined   : "undefined",
}
export const enum_langCodes = {
    english : 'en',
    hebrew  : 'iw',
    french  : 'fr',
    spanish : 'es',
    arabic  : 'ar',
    dutch   : 'nl',
}
export const enum_questTicketActions =  {
    verifyPayment   : "verifyPayment",
    approve         : "approve",
    cancel          : "cancel",
    expire          : "expire",
    reminder        : "reminder",
    charge          : "charge",
    change          : "change",

    // todo: remove - deprecated
    creatorRequest  : "creatorRequest",
    creatorRequestApproved     : "creatorRequestApproved",
    creatorRequestDecline      : "creatorRequestDecline",
}
export const enum_questEventStartClockTypes_s =  {
    eventStartClock     : "eventStartClock",
    playerStartClock    : "playerStartClock",
    creatorStartClock   : "creatorStartClock",
}
export const enum_fileType = {

    IMG_jpeg: 'image/jpeg',
    IMG_png: 'image/png',
    IMG_svg: 'image/svg+xml',
    IMG_gif: 'image/gif',
    IMG_wav: 'audio/wav',

    video_mp4: 'video/mp4',
    video_quicktime: 'video/quicktime',

    audio_mpeg: 'audio/mpeg',
    audio_ogg: 'audio/ogg',
    audio_mp3: 'audio/mp3',

    folder: 'folder',

    IMG     : 'image',
    VIDEO   : 'video',
    AUDIO   : 'audio'
}
export const enum_ipn_status = {
    VERIFIED: 'VERIFIED',
}
export const enum_timeUnits = {
    days : 'days',
    hours : 'hours',
    minutes : 'minutes',
    seconds : 'seconds',
    milliseconds : 'milliseconds',
}
export const enum_lockTypes = {
    REGULAR_EXPRESSION  : "REGULAR_EXPRESSION",
    WORDS               : "WORDS",
    OPTIONS             : "OPTIONS",
    INCLUDE_WORD        : "INCLUDE_WORD",
    // FACEBOOK            : "FACEBOOK",

    TRIVIA  : "TRIVIA",
    QUIZ    : "Quiz",
    QR_CODE : "QR_CODE",
    IMAGE   : "IMAGE",
    VIDEO   : "VIDEO",
    GPS     : "GPS",

    IMAGE_WITHOUT_APPROVED   : "IMAGE_WITHOUT_APPROVED",

}
export const enum_questEventStatus = {
    waiting : 'waiting',
    ongoing_inactive: 'ongoing_inactive',       // creator didnt activate the quest event
    ongoing : 'ongoing',
    finish  : 'finish',
    didntStart  : 'didntStart',
}
export const enum_serverRequestType = {
    get_onlyServer            : 'get_onlyServer',

    get_firstStorage          : 'get_firstStorage',
    get_onlyStorage           : 'get_onlyStorage',
    get_storageFirstAndUpdate : 'get_storageFirstAndUpdate',

    save_storage            : 'save_storage',
    delete_storage          : 'delete_storage',
}
export const enum_moveToOptions = {

    root : "/",
    root_sub : "/player-tickets",

    // store
    player_store                        : '/store',
    player_store_quest                  : '/store/quest',
    player_store_creator                : '/store/creator',
    player_store_category               : '/store/category',
    player_store_whiteLabel             : '/store/whitelabel',
    player_store_agent                  : '/store/agent',

    player_play                         : '/',
    player_play_list                    : '/',
    player_play_entry_ticket            : '/entry-ticket',

    player_profile                      : '/profile',

    creator                             : '/creator',
    creator_events                      : '/creator/events',
    creator_events_list                 : '/creator/events/list',
    creator_events_item                 : '/creator/events/item',
    creator_edit                        : '/creator/edit',
    creator_edit_item                   : '/creator/edit/item',
    creator_edit_create                 : '/creator/edit/create',
    creator_edit_list                   : '/creator/edit/list',
    creator_profile                     : '/creator/profile',

    ongoing                             : '/ongoing',
    ongoing_status                      : '/ongoing/status',
    ongoing_status_review               : '/ongoing/status/review',
    ongoing_chat                        : '/ongoing/chat',
    ongoing_camera                      : '/ongoing/camera',
    ongoing_questRules                  : '/ongoing/questRules',
    ongoing_Missions                    : '/ongoing/missions',
    ongoing_Missions_List               : '/ongoing/missions/list',
    ongoing_Missions_Item               : '/ongoing/missions/item',
    ongoing_Missions_Last               : '/ongoing/missions/last',
    ongoing_quest_cards                 : '/ongoing/quest/cards',
    ongoing_quest_openMap               : '/ongoing/quest/openMap',
    ongoing_quest_openMap_lastRiddles   : '/ongoing/quest/openMap/lastRiddles',
    ongoing_quest_openMap_riddle        : '/ongoing/quest/openMap/riddle',
    ongoing_quest_openMap_map           : '/ongoing/quest/openMap/map',
    ongoing_quest_openMapPolygons       : '/ongoing/quest/polygonsOpenMap',
    ongoing_quest_openMapPolygons_missions: '/ongoing/quest/polygonsOpenMap/missions',
    ongoing_quest_openMapPolygons_riddle: '/ongoing/quest/polygonsOpenMap/riddle',

    terms                       : '/terms',
    terms_cookiePolicy          : '/terms/cookiePolicy',
    terms_creatorPolicy         : '/terms/creatorPolicy',
    terms_disclaimer            : '/terms/disclaimer',
    terms_privacyPolicy         : '/terms/privacyPolicy',
    terms_termsOfUse            : '/terms/termsOfUse',

    standAlong_TOS              : '/TOS',
    standAlong_PP               : '/privacyPolicy',
    standAlong_RP               : '/refundPolicy',
    standAlong_welcome          : '/welcome',
    standAlong_about            : '/about',
    standAlong_pricing          : '/pricing',
    standAlong_questType        : '/quest-type',
    standAlong_locksTypeInfo    : '/locks-types-info',
    standAlong_paymentFailed    : '/paymentFailed',
    standAlong_paymentSuccess   : '/paymentSuccess',
    standAlong_iframeSuccessMsg : '/iframeSuccessMsg',
    standAlong_iframeFailedMsg  : '/iframeFailedMsg',

    admin         : '/admin',
    admin_quests  : '/admin/quests',
    admin_users   : '/admin/users',
    admin_events  : '/admin/events',
    admin_tickets : '/admin/tickets',
    admin_blog    : '/admin/blog',
    admin_reviewsReports    : '/admin/reports',
    admin_moreInfo          : '/admin/moreInfo',
    admin_errors          : '/admin/errors',
    admin_discountCoupons   : '/admin/discountCoupons',
    admin_actions           : '/admin/actions',
}
export const enum_lockQuestionsTypes = {
    WORDS       : "WORDS",
    OPTIONS     : "OPTIONS",
    INCLUDE_WORD: "INCLUDE_WORD",
}
export const enum_urlParams = {
    ticketId            : 'ticketId',
    questId             : 'questId',
    playersNum          : 'playersNum',

    userEmail           : 'userEmail',
    userPhone           : 'userPhone',
    username            : 'username',
    userPassword        : 'userPassword',
    datetime            : 'datetime',

    agentId             : 'agentId',
    eventId             : 'eventId',

    missionRiddleId_n   : 'missionRiddleId_n',
    riddleId_n          : 'riddleId_n',
    groupId_n           : 'groupId_n',
    onlyReviews         : 'onlyReviews',

    msg                 : 'msg',

    loginHideGoogle     : 'loginHideGoogle',

}
export const enum_notifyComponent = {
    si_unlock       : 'si_unlock',
    si_clue         : 'si_clue',
    si_skip         : 'si_skip',
    si_finishRiddle : 'si_finishRiddle',
    si_finishQuest : 'si_finishQuest',
}
export const enum_loginMethods = {
    google      : "google.com",
    facebook    : "facebook",
    // twitter     : "twitter",
    email       : "password",
    guest       : "guest",

    // phone       : "phone",
}
export const enum_moveToLocationOptions = {
    creator : 'creator',
    player  : 'player',
    ongoing : 'ongoing',
    admin : 'admin'
}
export const enum_dropdownMode = {
    select      : 'select',
    dropdown    : 'dropdown'
}
export const enum_NODE_ENV = {
    production  : 'production',
    development  : 'development',
}
export const enum_subCollection_teamStatus = {
    MAP_MISSIONS        : "MAP_MISSIONS",
    MAP_LAST_MISSIONS   : "MAP_LAST_MISSIONS",
    CARDS_MISSIONS      : "CARDS_MISSIONS",
    LIST_MISSIONS       : "LIST_MISSIONS",
    LIST_LAST_MISSIONS  : "LIST_LAST_MISSIONS",
}

export const enum_chatMsgStatus = {
    send : 'send',
    receiveByAll : 'receiveByAll',
    readByAll:'readByAll'
}
export const enum_cardsDirections = {
    left : 'left',
    right : 'right',
}
export const enum_directions = {
    ltr : 'ltr',
    rtl : 'rtl'
}
export const enum_oppositeOperators = {
    '+' : "-",
    '-' : "+",
}
export const enum_osNames = {
    ios     : 'IOS',
    android : 'Android',
    windows : 'Windows',
}

export const enum_eventsListenersNames = {
    pointerdown : 'pointerdown',
    pointermove : 'pointermove',
    pointerup   : 'pointerup',

    click       : 'click',
    moveend     : 'moveend',

    drawend     : 'drawend',
    modifyend   : 'modifyend',

    touchstart  : 'touchstart',
    touchcancel : 'touchcancel',
    touchmove   : 'touchmove',
    touchend    : 'touchend',

    scroll      : 'scroll',

    focus       : 'focus',
    blur        : 'blur',
    deviceorientation    : 'deviceorientation',

    windows_load    : "load",
    windows_online  : "online",
    windows_offline : "offline",
    window_resize   : 'resize',

    message   : 'message',

    mousedown : 'mousedown',
    mouseover : 'mouseover',
    mouseout  : 'mouseout',

    controllerchange : 'controllerchange',

    beforeinstallprompt : 'beforeinstallprompt',

    change : 'change'

}
export const enum_mapMissionsTypes = {
    markers         : 'markers',
    markers_route   : 'markers_route',

    squares         : 'squares',
    squares_linear  : 'squares_linear',
    squares_linear_groups  : 'squares_linear_groups',
    squares_linear_groups_hide  : 'squares_linear_groups_hide',

    squares_hide    : 'squares_hide',
    numbers_hide    : 'numbers_hide',

    polygons        : 'polygons',
    polygons_area   : 'polygons_area',
}
export const enum_mapTypes = {
    none        : 'none',
    osm         : 'osm',
    googleMap   : 'googleMap',
}

export const enum_questTicketStatus =  {

    approved         : "approved",
    canceled         : "canceled",

    // todo: remove - deprecated
    charged          : "charged",
    expired          : "expired",
    waitingToApprove : "waitingToApprove",

    // todo: remove - deprecated
    creatorRequest             : "creatorRequest",
    creatorRequestApproved     : "creatorRequestApproved",
    creatorRequestDecline      : "creatorRequestDecline",
}
export const enum_questDiscountCouponHistory_status =  {
    enteredCode  : "enteredCode",
    usedCoupon  : "usedCoupon",
}
export const enum_endPoint_checkCoupon_options =  {
    available   : "available",
    full        : "full",
    notExisting : "notExisting",
}

export const enum_accessLevel_byAccessName = {
    route_admin             : enum_accessLevelOptions.admin,
    route_creator           : enum_accessLevelOptions.guide,
    route_creator_dashboard : enum_accessLevelOptions.creator,
    route_creator_editQuests: enum_accessLevelOptions.creator,

    creator_events_createEventBtn   : enum_accessLevelOptions.creator,
    creator_event_buyTicketBtn      : enum_accessLevelOptions.creator,
}
export const enum_lockState = {
    waitingToApprove : "waitingToApprove",
    approved : "approved",
    notApproved : "notApproved",
}
export const enum_storeIn = {
    none            : 'none',
    localStorage    : 'localStorage',
    sessionStorage  : 'sessionStorage',
}
export const enum_shareOptions = {
    facebook    : 'facebook',
    whatsapp    : 'whatsapp',
    twitter     : 'twitter',
    gmail       : 'gmail',
    email       : 'email',
}
export const enum_domExceptionsNames = {
    NotAllowedError : 'NotAllowedError',
    NotFoundError   : 'NotFoundError',
}
export const enum_loginErrors = {
    EMAIL_NOT_FOUND     : 'EMAIL_NOT_FOUND',
    INVALID_PASSWORD    : 'INVALID_PASSWORD',
    EMAIL_EXISTS        : 'EMAIL_EXISTS',
    USER_DISABLED       : 'USER_DISABLED',
    LOGIN_WITH_GOOGLE   : 'LOGIN_WITH_GOOGLE',
    LOGIN_WITH_FACEBOOK : 'LOGIN_WITH_FACEBOOK',

    popup_closed_by_user: 'popup_closed_by_user',


    FEDERATED_USER_ID_ALREADY_LINKED: 'FEDERATED_USER_ID_ALREADY_LINKED', // This credential is already associated with a different user account.
}

export const enum_cameraVideoModes = {
    preRecords : 'preRecords',
    recording   : 'recording',
    finishRecord   : 'finishRecord',
}
export const enum_colors = {
    blue        : 'var(--color-blue)',
    blue_lite   : 'var(--color-blue-lite)',
    green       : 'var(--color-green2)',
    gray1       : 'var(--color-gray1)',
    red         : 'var(--color-red)',
}
export const enum_TqClasses = {
    TQ_width_24px : 'TQ_width_24px',
    TQ_width_32px : 'TQ_width_32px',
    TQ_width_36px : 'TQ_width_36px',
    TQ_width_44px : 'TQ_width_44px',
    TQ_width_150px : 'TQ_width_150px',
    TQ_width_100px : 'TQ_width_100px',
    TQ_width_72px : 'TQ_width_72px',
    TQ_text_14px : 'TQ_text_14px',

    TQ_text_20px : 'TQ_text_20px',

}
export const enum_ajaxClassType_s = {
    GET : 'GET',
    POST : 'POST',
}

export const enum_runIn_es = {

    flutter_app         : "flutter_app",
    android_app         : "android_app",
    ios_app             : "ios_app",

    android_web_chrome  : "android_web_chrome",
    android_pwa_chrome  : "android_pwa_chrome",
    android_web_other   : "android_web_other",

    ios_web_chrome      : "ios_web_chrome",
    ios_web_safari      : "ios_web_safari",
    ios_pwa_safari      : "ios_pwa_safari",
    ios_web_other       : "ios_web_other",

    windows_chrome      : "windows_chrome",
    windows_other       : "windows_other",

    mac_chrome          : "mac_chrome",
    mac_safari          : "mac_safari",
    mac_other           : "mac_other",

    other               : "other",

}

export const enum_availableTicketsTypes_s = {
    specificTicket : "specificTicket",
    gradualTicket : "gradualTicket",
}


export const enum_routeScrollableMode_e = {
    topToBottom : "topToBottom",
    bottomToTop : "bottomToTop",
    noScrolling : "noScrolling",
}

export const enum_cluesMode_e = {
    none    : "none",
    counter : "counter",
    counter_gradual : "counter_gradual",
    points  : "points",
    points_gradual  : "points_gradual",
}

export const enum_arrangeMissionsType_s = {
    none                    : "none",
    random                  : "random",
    player_choose_oneTime   : "player_choose_oneTime",
    team_choose_oneTime     : "team_choose_oneTime",
}

export const mapTilerStyles_s = {
    english : "https://api.maptiler.com/maps/d7fd46d0-0883-4ca1-a9a7-52d97dfe2ba0/style.json?key=Yrl4mrmcYMMeJU7w6a49",
    hebrew  : "https://api.maptiler.com/maps/900ecdd5-9427-4fa6-8ee2-7f2884582447/style.json?key=Yrl4mrmcYMMeJU7w6a49",
    french  : "https://api.maptiler.com/maps/81515431-dbb9-47a3-b935-fd924b3a0fe2/style.json?key=Yrl4mrmcYMMeJU7w6a49",
    spanish : "https://api.maptiler.com/maps/5793fc1b-cc6b-4c6d-b433-10110f4dbb63/style.json?key=Yrl4mrmcYMMeJU7w6a49",
    default : "https://api.maptiler.com/maps/21d59480-0c7b-4dba-9e28-160daadbb7c7/style.json?key=Yrl4mrmcYMMeJU7w6a49",
}

export const enum_finishQuest_s = {
    listMissions_last       : "listMissions_last",
    listMissions_all        : "listMissions_all",
    mapMissions_finishAll   : "mapMissions_finishAll",
    listMissions_none       : "listMissions_none",
    none                    : "none",
    mapLastRiddle           : "mapLastRiddle",
    cardsLastRiddle         : "cardsLastRiddle",
}

export const enum_questMode_s = {
    teams : "teams",
    individual  : "singlePlayer",
}

// ====== to check =================

export const enum_questLocationsTypes_s = {
    outside : "outdoor", // outdoor - old name
    virtual : "online",  // online - old name
}

export const enum_colors_s = {
    red : "red",
    green : "green",
    blue : "blue",
}

export const enum_elementHtmlTypes_s ={
    IMG : "IMG"
}

export const enum_banks_n ={
    Yahav           : 4,
    Leumi           : 10,
    Discount        : 11,
    Hapoalim        : 12,
    OtsarHaHayal    : 14,
    Mercantile      : 17,
    MizrahiTefahot  : 20,
    fibi            : 31,
}


export const enum_reportReviewStatus_e ={
    close   : "close",
    open    : "open",

}

// enum_missions_LocksType_s
export const enum_missions_LocksType_s = {
    regular     : 'regular',
    start_time  : 'start_time',
}

// enum_missions_LocksType_s
export const enum_missions_Locks_video_time = {
    sec40  : 40,
    sec30  : 30,
    sec20  : 20,
    sec10  : 10,
}

// enum_projectEnv_s
export const enum_projectEnv_s = {
    tq_dev : 'tq_dev',
    tq_pro : 'tq_pro',
    tq_nice : 'tq_nice',
}



// saleType_byLabel_n
export const enum_saleType_n = {
    immediate : 1,
    waiting : 2,  // J5
    token: 3
}



// avatar
export const enum_avatar_top_e = {
    NoHair : 'NoHair',
    Hat : 'Hat',
    Hijab : 'Hijab',
    Turban : 'Turban',

    WinterHat1 : 'WinterHat1',
    WinterHat2 : 'WinterHat2',
    WinterHat3 : 'WinterHat3',
    WinterHat4 : 'WinterHat4',

    BigHair : 'BigHair',
    Bob : 'Bob',
    Bun : 'Bun',
    Curly : 'Curly',
    Curvy : 'Curvy',
    Dreads : 'Dreads',
    Frida : 'Frida',
    Fro : 'Fro',
    FroBand : 'FroBand',
    LongButNotTooLong : 'LongButNotTooLong',
    ShavedSides : 'ShavedSides',
    MiaWallace : 'MiaWallace',
    Straight : 'Straight',
    StraightStrand : 'StraightStrand',

    Dreads1 : 'Dreads1',
    Dreads2 : 'Dreads2',

    Frizzle : 'Frizzle',
    ShaggyMullet : 'ShaggyMullet',
    ShortCurly : 'ShortCurly',
    ShortFlat : 'ShortFlat',
    ShortRound : 'ShortRound',
    ShortWaved : 'ShortWaved',
    Sides : 'Sides',
    TheCaesar : 'TheCaesar',
    TheCaesarSidePart : 'TheCaesarSidePart',

}
export const enum_avatar_clothing_e = {
    BlazerShirt : 'BlazerShirt',
    BlazerSweater : 'BlazerSweater',
    CollarSweater : 'CollarSweater',
    GraphicShirtBat : 'GraphicShirtBat',
    GraphicShirtCumbia : 'GraphicShirtCumbia',
    GraphicShirtDeer : 'GraphicShirtDeer',
    GraphicShirtDiamond : 'GraphicShirtDiamond',
    GraphicShirtHola : 'GraphicShirtHola',
    GraphicShirtPizza : 'GraphicShirtPizza',
    GraphicShirtResist : 'GraphicShirtResist',
    GraphicShirtSelena : 'GraphicShirtSelena',
    GraphicShirtBear : 'GraphicShirtBear',
    GraphicShirtSkullOutline : 'GraphicShirtSkullOutline',
    GraphicTQ : 'GraphicTQ',
    GraphicShirtSkull : 'GraphicShirtSkull',
    Hoodie : 'Hoodie',
    Overall : 'Overall',
    ShirtCrewNeck : 'ShirtCrewNeck',
    ShirtScoopNeck : 'ShirtScoopNeck',
    ShirtVNeck : 'ShirtVNeck',
}
export const enum_avatar_eyes_e = {
    Default : 'Default',
    Closed : 'Closed',
    Cry : 'Cry',
    Dizzy : 'Dizzy',
    Happy : 'Happy',
}
export const enum_avatar_mouth_e = {
    Default : 'Default',
    Concerned : 'Concerned',
    Disbelief : 'Disbelief',
    Eating : 'Eating',
    Grimace : 'Grimace',
    Sad : 'Sad',
    Smile : 'Smile',
    Tongue : 'Tongue',
    Vomit : 'Vomit',
}
export const enum_avatar_eyebrow_e = {
    Default : 'Default',
    Angry : 'Angry',
    AngryNatural : 'AngryNatural',
    DefaultNatural : 'DefaultNatural',
    FlatNatural : 'FlatNatural',
    RaisedExcited : 'RaisedExcited',
    RaisedExcitedNatural : 'RaisedExcitedNatural',
    SadConcerned : 'SadConcerned',
    SadConcernedNatural : 'SadConcernedNatural',
    UnibrowNatural : 'UnibrowNatural',
    UpDown : 'UpDown',
    UpDownNatural : 'UpDownNatural',
}
export const enum_avatar_top_facialHair_e = {
    blank : 'blank',
    BeardMedium : 'BeardMedium',
    BeardLight : 'BeardLight',
    BeardMajestic : 'BeardMajestic',
    MoustacheFancy : 'MoustacheFancy',
    MoustacheMagnum : 'MoustacheMagnum',

}
export const enum_avatar_top_accessories_e = {
    blank : 'blank',
    Eyepatch : 'Eyepatch',
    Kurt : 'Kurt',
    Prescription01 : 'Prescription01',
    Prescription02 : 'Prescription02',
    Round : 'Round',
    Sunglasses : 'Sunglasses',
    Wayfarers : 'Wayfarers',

}
export const enum_inputType = {
    number_s : 'number',
    text_s : 'text',
    email_s : 'email',
    password_s : 'password',

}

// enum_iframeMsg
export const enum_iframeMsg = {
    success_s : "success",
    failed_s : "failed",
}

// enum_actionsPoints
export const enum_actionsPoints = {

    // once
    once_likePage_n           : 10,
    once_firstJoinPlayer_n    : 10,
    once_createUser_n         : 10,
    once_createFirstQuest_n   : 10,
    once_createFirstMission_n : 10,
    once_googleLogin_n        : 10,
    once_facebookLogin_n      : 10,
    once_enterBankInfo_n      : 10,
    once_enterCreditCard_n    : 10,

    // gain points
    joinedPlayer_n            : 10,
    playQuest_n               : 10,
    finishQuest_n             : 10,

}

// enum_articlesIds
export const enum_articlesIds = {
    questsType_uid  : "-Ln84T2tpKsetk8F-JW-",
    locksType_uid   : "bnfSo78JyGrJxAwcYdk8",
    pricing_uid     : "-MRJhz8T8Mdwt1EXA1VT",
}

// enum_moreInfo_featuresIds_s
export const enum_moreInfo_featuresIds_s = {

    feature_numQuests_1                     : 'feature_numQuests_1',
    feature_numQuests_2                     : 'feature_numQuests_2',
    feature_numQuests_3                     : 'feature_numQuests_3',
    feature_numQuests_4                     : 'feature_numQuests_4',
    feature_numQuests_6                     : 'feature_numQuests_6',
    feature_numQuests_8                     : 'feature_numQuests_8',
    feature_numQuests_10                    : 'feature_numQuests_10',
    feature_numQuests_15                    : 'feature_numQuests_15',
    feature_numQuests_20                    : 'feature_numQuests_20',

    feature_lock_text                       : 'feature_lock_text',
    feature_lock_options                    : 'feature_lock_options',
    feature_lock_includeWord                : 'feature_lock_includeWord',
    feature_lock_quiz                       : 'feature_lock_quiz',
    feature_lock_image                      : 'feature_lock_image',
    feature_lock_timer                      : 'feature_lock_timer',         // todo: add creator support
    feature_lock_video                      : 'feature_lock_video',

    feature_quest_list_reg                  : 'feature_quest_list_reg',
    feature_quest_cards                     : 'feature_quest_cards',
    feature_quest_map_route                 : 'feature_quest_map_route',
    feature_quest_map_markers               : 'feature_quest_map_markers',
    feature_quest_list_group                : 'feature_quest_list_group',
    feature_quest_list_level                : 'feature_quest_list_level',
    feature_quest_cards_diffPath_team       : 'feature_quest_cards_diffPath_team',
    feature_quest_map_lastMissions          : 'feature_quest_map_lastMissions',
    feature_quest_map_squares               : 'feature_quest_map_squares',
    feature_quest_cards_diffPath_player     : 'feature_quest_cards_diffPath_player',
    feature_quest_map_area                  : 'feature_quest_map_area',

    feature_duration_2Hour                  : 'feature_duration_2Hour',
    feature_duration_3Hour                  : 'feature_duration_3Hour',
    feature_duration_6Hour                  : 'feature_duration_6Hour',
    feature_duration_12Hour                 : 'feature_duration_12Hour',
    feature_duration_24Hour                 : 'feature_duration_24Hour',
    feature_duration_3Days                  : 'feature_duration_3Days',
    feature_duration_7Days                  : 'feature_duration_7Days',

    feature_timeExtension_quarter           : 'feature_timeExtension_quarter',
    feature_timeExtension_half              : 'feature_timeExtension_half',
    feature_timeExtension_one               : 'feature_timeExtension_one',
    feature_timeExtension_twice             : 'feature_timeExtension_twice',

    feature_clues_points_gradual            : 'feature_clues_points_gradual',
    feature_clues_points_select             : 'feature_clues_points_select',
    feature_clues_counter_gradual           : 'feature_clues_counter_gradual',
    feature_clues_counter_select            : 'feature_clues_counter_select',

    feature_general_quest_player            : 'feature_general_quest_player',
    feature_general_quest_team              : 'feature_general_quest_team',

    feature_general_lang_two                : 'feature_general_lang_two',
    feature_general_lang_multi              : 'feature_general_lang_multi',

    feature_general_headquarters            : 'feature_general_headquarters',
    feature_general_tqDrive                 : 'feature_general_tqDrive',
    feature_general_skips                   : 'feature_general_skips',
    feature_general_tqStore                 : 'feature_general_tqStore',

    feature_general_chat                    : 'feature_general_chat',
    feature_general_chat_translation        : 'feature_general_chat_translation',
    feature_general_discountCoupon10        : 'feature_general_discountCoupon10%',
    feature_general_discountCoupon20        : 'feature_general_discountCoupon20%',
    feature_general_discountCoupon30        : 'feature_general_discountCoupon30%',
    feature_general_lastSection             : 'feature_general_lastSection',
    feature_general_backgroundImage         : 'feature_general_backgroundImage',
    feature_general_editQuestAudio          : 'feature_general_editQuestAudio',

    // feature_general_chat_image              : 'feature_general_chat_image',

}

// enum_featuresMinPoints
export const enum_featuresMinPoints = {

    // level0
    [enum_moreInfo_featuresIds_s.feature_numQuests_1]                   : 0,
    [enum_moreInfo_featuresIds_s.feature_quest_list_reg]                : 0,
    [enum_moreInfo_featuresIds_s.feature_lock_text]                     : 0,
    [enum_moreInfo_featuresIds_s.feature_duration_2Hour]                : 0,
    [enum_moreInfo_featuresIds_s.feature_general_quest_player]          : 0,
    [enum_moreInfo_featuresIds_s.feature_general_headquarters]          : 0,
    [enum_moreInfo_featuresIds_s.feature_general_tqDrive]               : 0,
    [enum_moreInfo_featuresIds_s.feature_timeExtension_quarter]         : 0,

    // level1 (up to 2000) (0-200 pp)
    [enum_moreInfo_featuresIds_s.feature_numQuests_2]                   : 200,
    [enum_moreInfo_featuresIds_s.feature_lock_options]                  : 400,
    [enum_moreInfo_featuresIds_s.feature_clues_points_gradual]          : 500,
    [enum_moreInfo_featuresIds_s.feature_numQuests_3]                   : 800,
    [enum_moreInfo_featuresIds_s.feature_quest_cards]                   : 1000,
    [enum_moreInfo_featuresIds_s.feature_duration_3Hour]                : 1200,
    [enum_moreInfo_featuresIds_s.feature_general_chat]                  : 1500,
    [enum_moreInfo_featuresIds_s.feature_timeExtension_half]            : 1800,

    // level2 (up to 6000) (200- 600 pp)
    [enum_moreInfo_featuresIds_s.feature_general_tqStore]               : 2000,
    [enum_moreInfo_featuresIds_s.feature_numQuests_4]                   : 2500,
    [enum_moreInfo_featuresIds_s.feature_general_discountCoupon10]      : 3000,
    [enum_moreInfo_featuresIds_s.feature_quest_map_route]               : 4000,
    [enum_moreInfo_featuresIds_s.feature_clues_points_select]           : 4500,
    [enum_moreInfo_featuresIds_s.feature_lock_includeWord]              : 5000,
    [enum_moreInfo_featuresIds_s.feature_numQuests_6]                   : 5200,
    [enum_moreInfo_featuresIds_s.feature_general_lang_two]              : 5500,

    // level3 (up to 12000) (600-1200 pp)
    [enum_moreInfo_featuresIds_s.feature_general_discountCoupon20]      : 6000,
    [enum_moreInfo_featuresIds_s.feature_lock_quiz]                     : 6500,
    [enum_moreInfo_featuresIds_s.feature_duration_6Hour]                : 7000,
    [enum_moreInfo_featuresIds_s.feature_quest_list_group]              : 7500,
    [enum_moreInfo_featuresIds_s.feature_numQuests_8]                   : 8000,
    [enum_moreInfo_featuresIds_s.feature_quest_map_markers]             : 8500,
    [enum_moreInfo_featuresIds_s.feature_quest_list_level]              : 9000,
    [enum_moreInfo_featuresIds_s.feature_duration_12Hour]               : 10000,
    [enum_moreInfo_featuresIds_s.feature_quest_cards_diffPath_team]     : 11000,

    // level4 (up to 20000) (1200-2000 pp)
    [enum_moreInfo_featuresIds_s.feature_general_quest_team]            : 12000,
    [enum_moreInfo_featuresIds_s.feature_numQuests_10]                  : 12500,
    [enum_moreInfo_featuresIds_s.feature_lock_image]                    : 13000,
    [enum_moreInfo_featuresIds_s.feature_quest_map_squares]             : 13500,
    [enum_moreInfo_featuresIds_s.feature_clues_counter_gradual]         : 14000,
    [enum_moreInfo_featuresIds_s.feature_quest_map_lastMissions]        : 15000,
    [enum_moreInfo_featuresIds_s.feature_clues_counter_select]          : 16000,
    [enum_moreInfo_featuresIds_s.feature_general_lastSection]           : 17000,
    [enum_moreInfo_featuresIds_s.feature_lock_timer]                    : 18000,
    [enum_moreInfo_featuresIds_s.feature_general_skips]                 : 19000,


    // level5 (up to 30000) (2000-3000 pp)
    [enum_moreInfo_featuresIds_s.feature_numQuests_15]                  : 20000,
    [enum_moreInfo_featuresIds_s.feature_quest_cards_diffPath_player]   : 21000,
    [enum_moreInfo_featuresIds_s.feature_general_lang_multi]            : 22000,
    [enum_moreInfo_featuresIds_s.feature_duration_24Hour]               : 24000,
    [enum_moreInfo_featuresIds_s.feature_timeExtension_one]             : 26000,
    [enum_moreInfo_featuresIds_s.feature_general_discountCoupon30]      : 28000,


    // level6 (up to 42000) (3000-4200 pp)
    [enum_moreInfo_featuresIds_s.feature_general_editQuestAudio]        : 30000,
    [enum_moreInfo_featuresIds_s.feature_numQuests_20]                  : 32000,
    [enum_moreInfo_featuresIds_s.feature_quest_map_area]                : 34000,
    [enum_moreInfo_featuresIds_s.feature_lock_video]                    : 36000,
    [enum_moreInfo_featuresIds_s.feature_general_chat_translation]      : 38000,
    [enum_moreInfo_featuresIds_s.feature_duration_3Days]                : 40000,
    [enum_moreInfo_featuresIds_s.feature_general_backgroundImage]       : 45000,
    [enum_moreInfo_featuresIds_s.feature_timeExtension_twice]           : 50000,
    [enum_moreInfo_featuresIds_s.feature_duration_7Days]                : 55000,



}

// enum_moreInfo_helpersIds_s
export const enum_moreInfo_helpersIds_s = {


    // edit
    helpers_edit_quest               : 'helpers_edit_quest',

    helpers_edit_overview            : 'helpers_edit_overview',
    helpers_edit_intro_basicInfo     : 'helpers_edit_intro_basicInfo',
    helpers_edit_intro_pricing       : 'helpers_edit_intro_pricing',

    helpers_edit_quest_cardMissions  : 'helpers_edit_quest_cardMissions',

    helpers_edit_quest_links         : 'helpers_edit_quest_links',
    helpers_edit_quest_explore       : 'helpers_edit_quest_explore',
    helpers_edit_quest_body          : 'helpers_edit_quest_body',

    helpers_edit_map_route           : 'helpers_edit_map_route',
    helpers_edit_permission          : 'helpers_edit_permission',

    helpers_edit_mission_locks       : 'helpers_edit_mission_locks',
    helpers_edit_mission_hints       : 'helpers_edit_mission_hints',
    helpers_edit_mission_lastSection : 'helpers_edit_mission_lastSection',

    // event
    helpers_event_store_link         : 'helpers_event_store_link',
    helpers_event_clock_types        : 'helpers_event_clock_types',

    // helpers_createQuest
    helpers_createQuest              : 'helpers_createQuest',

}

// enum_moreInfo_versionsRelease_s
export const enum_moreInfo_versionsRelease_s = {
    "2021_07_01" : "2021_07_01",
    "2021_06_01" : "2021_06_01",
    "2021.09.01" : "2021_09_01",
    "3021_11_01" : "3021_11_01",
}

// enum_levelLabels
export const enum_levelLabels = {

    level0    : "level0",
    level1    : "level1",
    level2    : "level2",
    level3    : "level3",
    level4    : "level4",
    level5    : "level5",
    level6    : "level6",
    // level7    : "level7",
    // level8    : "level8",
    // level9    : "level9",
    // level10   : "level10",

}

// enum_levelMaxPoints
export const enum_levelMaxPoints = {

    [enum_levelLabels.level0]   : 0,
    [enum_levelLabels.level1]   : 2000,
    [enum_levelLabels.level2]   : 6000,
    [enum_levelLabels.level3]   : 12000,
    [enum_levelLabels.level4]   : 20000,
    [enum_levelLabels.level5]   : 30000,
    // [enum_levelLabels.level6]   : 42000,
    // [enum_levelLabels.level7]   : 56000,
    // [enum_levelLabels.level8]   : 72000,
    // [enum_levelLabels.level9]   : 90000,

}

// enum_creatorSendPaymentStatus
export const enum_creatorSendPaymentStatus  = {
    didntSend   : 'didntSend',
    sent        : "sent",
    receivedReceipt        : "receivedReceipt",
}

// enum_creatorChargePaymentStatus
export const enum_creatorChargePaymentStatus  = {
    didntCharge   : 'didntCharge',
    charged       : "charged",
}

// enum_emailsIds_uid
export const enum_emailsIds_uid  = {

    monthlySum                          : "3jYHe0ysEhZ9JOq2AdFT",
    monthlySum_sentCreatorPayment       : 'QNAFzRXoPXpNj0RRNVzD',
    monthlySum_receivedCreatorPayment   : "mkQ3YYIBBeCvuwjLY1Rn",
    monthlySum_subscriptionCharge       : "subscriptionCharge",

    ongoing_newReview                   : "u2LxbGozS44wsLvWBIay",
    ongoing_finishQuest                 : "ongoing_finishQuest",

    creatorNewFeature                   : "creatorNewFeature",

    ticket_approved                     : "JrIUtXJSfc179ugfsaO2",
    ticket_waitingForApproved           : "ticket_waitingForApproved",
    ticket_receipt                      : "PO3u9jXn6l3H7WSDMdaQ",
    ticket_cancel                       : "ticket_cancel",

    welcomeNewCreator                   : "RxsUS1TAKOONLp5PG1WU",

    receivedEmail                       : "receivedEmail",
}

// enum_audio
export const enum_audioUrl = {
    notify_s : 'https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2FAudio%2Fnotify.wav?alt=media&token=282b2fb3-3d28-41a9-891c-329b199c5712',
    claps_s  : 'https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2FAudio%2FfinishRiddle.mp3?alt=media&token=c2ddfeed-8a3e-45d8-b9d2-1d3334655cfe',
    error_s  : 'https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2FAudio%2Ferror.wav?alt=media&token=4a057509-75ac-4779-87b0-63dcb07dea26',
    lastRiddle_s  : 'https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2FAudio%2FfinishLastRiddle.mp3?alt=media&token=b902d745-7944-4cfa-bf60-55ca2f5a1ea5',
}

// enum_audio
export const enum_questCategories = {
    virtual     : "virtual",
    outside     : "outside",
    teamWork    : "teamWork",
    selfGuided  : "selfGuided",

}

// enum_moreInfoImgOptions_e
export const enum_moreInfoImgOptions_e  = {
    ass_img_info2_w : "ass_img_info2_w",
    ass_img_info2_b : "ass_img_info2_b",
    ass_img_featureHelper_b : "ass_img_featureHelper_b",
    ass_img_featureHelper_w : "ass_img_featureHelper_w",
    none : "none",
}

// enum_supportClueCodeTypes
export const enum_hiddenCodesTypes = {
    e_none_n    : 0,
    e_clueCounter_n : 1,
    e_points_n  : 2,
}

// enum_totalPointsIdPrefix
export const enum_totalPointsIdPrefix = {
    revealClue_s  : "rc",
    riddleLock_s  : "rl",
    hiddenClue_s  : "hc",
    bonusPoints_s : "bp"
}

// enum_subscriptionTypes
export const enum_subscriptionTypes = {
    monthly : "monthly",
    yearly: "yearly"
}

// enum_serverEndPoints
export const enum_serverEndPoints = {
    endPoint_chargePayment :  "endPoint_chargePayment",
    endPoint_subscriptionCharge : "endPoint_subscriptionCharge"
}








